(() => {
  const body = document.body;

  function rootUrl(path = '') {
    const root = (window.StoerSop && window.StoerSop.root) || '/';
    return `${root}${path}`.replace(/\/\//g, '/');
  }

  function openCart() {
    body.classList.add('stoer-cart-open');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    body.classList.remove('stoer-cart-open');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  async function refreshCart(openAfter = false) {
    const base = (window.StoerSop && window.StoerSop.root) || '/';
    const url = `${base}?sections=stoer-cart-drawer,stoer-header`;
    const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Winkelwagen kon niet worden bijgewerkt.');
    const sections = await response.json();

    if (sections['stoer-cart-drawer']) {
      const current = document.getElementById('shopify-section-stoer-cart-drawer');
      if (current) current.outerHTML = sections['stoer-cart-drawer'];
    }
    if (sections['stoer-header']) {
      const current = document.getElementById('shopify-section-stoer-header');
      if (current) current.outerHTML = sections['stoer-header'];
    }

    if (openAfter) openCart();
  }

  async function addToCart(form, submitter) {
    const original = submitter ? submitter.textContent : '';
    if (submitter) {
      submitter.disabled = true;
      submitter.textContent = 'Toevoegen...';
    }

    try {
      const response = await fetch((window.StoerSop && window.StoerSop.cartAddUrl) || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) {
        let message = 'Dit product kon niet worden toegevoegd.';
        try {
          const data = await response.json();
          message = data.description || data.message || message;
        } catch (_) {}
        throw new Error(message);
      }

      if (submitter) submitter.textContent = 'Toegevoegd';
      await refreshCart(true);
    } catch (error) {
      window.alert(error.message || 'Er ging iets mis.');
    } finally {
      if (submitter && document.body.contains(submitter)) {
        window.setTimeout(() => {
          submitter.disabled = false;
          submitter.textContent = original || 'In winkelmand';
        }, 700);
      }
    }
  }

  async function changeQuantity(key, quantity) {
    try {
      const response = await fetch((window.StoerSop && window.StoerSop.cartChangeUrl) || '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('Aantal kon niet worden aangepast.');
      await refreshCart(true);
    } catch (error) {
      window.alert(error.message || 'Er ging iets mis.');
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-stoer-add-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form, event.submitter || form.querySelector('button[type="submit"]'));
  });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cart-open]');
    if (openButton) {
      event.preventDefault();
      openCart();
      return;
    }

    const closeButton = event.target.closest('[data-cart-close]');
    if (closeButton) {
      event.preventDefault();
      closeCart();
      return;
    }

    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) {
      event.preventDefault();
      const key = quantityButton.getAttribute('data-key');
      const quantity = Number(quantityButton.getAttribute('data-quantity'));
      if (key && Number.isFinite(quantity) && quantity >= 0) changeQuantity(key, quantity);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && body.classList.contains('stoer-cart-open')) closeCart();
  });
})();
